// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "../store/index";
import ElementUI from "element-ui";
// import smartRem from "smart-rem";
// smartRem(1920);
import echarts from "echarts";
import utils from "../api/utils";
import path from "./../api/url";
import http from "./../api/http";
import i18n from "./i18n/index";

import mqtt_protocol from "./../api/agreement/mqtt-agreement/mqtt_protocol";
import Recovery from "./../api/agreement/cr-agreement/recovery";
import { VueJsonp } from "vue-jsonp";
import { LOCAL_LANGUAGE } from "../api/localStorageName";

import "element-ui/lib/theme-chalk/index.css";
import en from "element-ui/lib/locale/lang/en";
import zh from "element-ui/lib/locale/lang/zh-CN";
import locale from "element-ui/lib/locale";
let language = navigator && navigator.language ? navigator.language : "zh-CN";
const local_language = localStorage.getItem(LOCAL_LANGUAGE);
language = local_language || language;
language = language.toUpperCase();
// const elementLang = language=='en'?en:zh
const elementLang = language.startsWith("ZH") ? zh : en;
locale.use(elementLang);

let Assemble = require("./../api/agreement/cr-agreement/assemble").Assemble;

Vue.prototype.$echarts = echarts;
Vue.prototype.$path = path;
Vue.prototype.$http = http;
Vue.prototype.$utils = utils;

Vue.prototype.$mqtt_protocol = mqtt_protocol;
Vue.prototype.$Recovery = Recovery;
Vue.prototype.$Assemble = Assemble;
import "element-ui/lib/theme-chalk/index.css";

ElementUI.Dialog.props.closeOnClickModal.default = false;
ElementUI.Table.props.stripe = {
  default: true,
  type: Boolean
};
Vue.use(ElementUI);
Vue.use(VueJsonp);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js